<template>
	<div ref="scrollContainer" class="simple-horizontal-scroll">
		<div class="scroll-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { debounce } from '@/utils/api';
import BScroll from 'better-scroll';

export default {
	name: 'SimpleHScroll',
	props: {
		// bs 实例存在重复事件派发情况，仅顶层 bs 节点才需要事件派发
		parent: {
			type: Boolean,
			default: true
		},
		bounce: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			bScroll: null
		};
	},
	mounted() {
		this.init();
		window.addEventListener('resize', this.listenResize);
	},
	beforeDestroy() {
		this.bScroll && this.bScroll.destroy();
		window.removeEventListener('resize', this.listenResize);
	},
	methods: {
		async init() {
			// 确保DOM已经渲染完成再初始化
			await this.$nextTick();

			const options = {
				mouseWheel: true, // Better-Scroll 将接管滚轮事件
				click: this.parent
					? /OpenHarmony|openHarmony|Android|webOS|iPhone|iPod/i.test(navigator.userAgent)
					: false,
				scrollX: true,
				scrollY: false,
				eventPassthrough: 'vertical',
				probeType: 3 // listening scroll event
			};

			// 额外配置支持
			options.bounce = this.bounce;

			const refs = this.$refs.scrollContainer;
			if (!refs) return;
			this.bScroll = new BScroll(refs, options);
		},
		refresh() {
			this.bScroll && this.bScroll.refresh();
		},
		scrollTo(...args) {
			this.bScroll && this.bScroll.scrollTo(...args);
		},
		getScrollX() {
			return this.bScroll && this.bScroll.x;
		},
		listenResize: debounce(function () {
			this.bScroll && this.bScroll.destroy();
			this.init();
		})
	}
};
</script>

<style lang="less" scoped>
.simple-horizontal-scroll {
	width: 100%;
	white-space: nowrap;
	overflow: hidden;

	.scroll-content {
		display: inline-block;
		min-width: 100%;

		// 兼容滚动区域内 第一次事件触发失效的情况
		// https://github.com/ustbhuangyi/better-scroll/issues/989
		::v-deep > * {
			pointer-events: auto !important;
		}
	}
}
</style>
